import React from 'react';
import generatePDF from 'react-to-pdf';
import {useDispatch, useSelector} from "react-redux";
import {setSelectedCountry, setSelectedCountryBelongsToOtherRegion, setYear} from "../features/map/mapSlice";
import {AppDispatch, RootState} from "../store/store";
import {availableYears} from "../config";
import {resetPins} from "../features/map/pinsSlice";
import { LATAM_COUNTRY_NAMES, ROMANIA_REGION } from "../features/countries/types";

const pxToCmRatio = 0.264583333;

const pxToCm = (px: number) => px * pxToCmRatio;

const hide = (toHide: Element[]) => {
    for (const elementsToHideElement of toHide) {
        // @ts-ignore
        elementsToHideElement.style.display = 'none';
    }
}
const show = (toShow: Element[]) => {
    for (const elementsToHideElement of toShow) {
        // @ts-ignore
        elementsToHideElement.style.display = '';
    }
}

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

const usePrintToPdf = (ref: React.Ref<HTMLElement>) => {
    const dispatch = useDispatch<AppDispatch>();
    const {
        countriesAll: {data: countriesAll},
    } = useSelector((state: RootState) => state);
    const [inProgress, setInProgress] = React.useState(false);
    const {data: geography} = useSelector((state: RootState) => state.mapApi);


    const createPDF = async (year: string, countryName: string) => {


        const toHide = Array.from(document.getElementsByClassName('hidden-print'));
        hide(toHide);

        const statsContainerStyles = document.getElementById('stats-container')?.style;
        const statsContainerStylesObj = {
            width: statsContainerStyles?.width,
            height: statsContainerStyles?.height,
            margin: statsContainerStyles?.margin
        }

        // @ts-ignore
        document.getElementById('stats-container').style.width = '100%';

        // @ts-ignore
        const preservedStatsContainerHeight = document.getElementById('stats-container').style.height;

        // @ts-ignore
        document.getElementById('stats-container').style.height = '31vh';
        // @ts-ignore
        document.getElementById('stats-container').style.margin = 'unset';

        // @ts-ignore
        const economicSectionPaddingTop = document.getElementById('economicSection').style.paddingTop;

        // @ts-ignore
        const economicSectionPadding = document.getElementById('economicSection').style.padding;

        // @ts-ignore
        document.getElementById('economicSection').style.padding = '25px';
        // @ts-ignore
        document.getElementById('economicSection').style.paddingTop = '40px';

        // @ts-ignore
        const employmentSectionPadding = document.getElementById('employmentSection').style.padding;
        // @ts-ignore
        document.getElementById('employmentSection').style.padding = '25px';

        const impactOverTime = document.getElementById('impactOverTime');

        if (impactOverTime) {
            impactOverTime.style.padding = '25px';
        }


        // @ts-ignore
        const statisticsBoxPadding = document.getElementById('statistics-box').style.padding;
        // @ts-ignore
        document.getElementById('statistics-box').style.padding = '25px';

        const preservedWidth = document.body.style.width;
        document.body.style.width = '1400px';


        const savedRef = {...ref};
        const pageProps = (document.getElementById('Page-id') as HTMLElement).getBoundingClientRect();

        const generate = generatePDF(savedRef as (() => HTMLElement | null), {
            filename: `Infographic_${countryName}_${year}.pdf`,
            page: {
                format: [pxToCm(1400), pxToCm(pageProps.height + 1)]
            }
        });


        // @ts-ignore
        document.getElementById('economicSection').style.padding = economicSectionPadding;
        // @ts-ignore
        document.getElementById('economicSection').style.paddingTop = economicSectionPaddingTop;
        // @ts-ignore
        document.getElementById('statistics-box').style.padding = statisticsBoxPadding;
        // @ts-ignore
        document.getElementById('employmentSection').style.padding = employmentSectionPadding;


        // @ts-ignore
        document.getElementById('stats-container').style.width = statsContainerStylesObj?.width;
        // @ts-ignore
        document.getElementById('stats-container').style.height = statsContainerStylesObj.height;
        // @ts-ignore
        document.getElementById('stats-container').style.margin = statsContainerStylesObj.margin;

        if (impactOverTime) {
            impactOverTime.style.padding = '140px 25px 50px 25px';
        }


        document.body.style.width = preservedWidth;
        show(toHide);

        await Promise.resolve(generate);
    }

    const generatePDFs = async () => {
        setInProgress(true);
        dispatch(resetPins());

        const yearsToGenerate = ['2024'];
        const years = yearsToGenerate.length ? yearsToGenerate : availableYears;
        for (const year of years) {
            console.log('selecting year', year);
            dispatch(setYear(year));
            let counter = 0;
            for (const country of countriesAll) {
                counter++;
                console.log(`selecting country ${country.country_name} (${counter}/${countriesAll.length})`);


                if (country.country_name.toUpperCase() === LATAM_COUNTRY_NAMES.CARICOM.toUpperCase()) {

                    const caricomCountry = countriesAll.find(
                        (country) => country.country_name.toUpperCase() === LATAM_COUNTRY_NAMES.CARICOM.toUpperCase()
                    );

                    const selectedCountryBelongsToCaricom = caricomCountry?.states.find(
                        // @ts-ignore
                        (state) => state.iso3 === geography?.properties?.iso3
                    );

                    dispatch(
                        setSelectedCountryBelongsToOtherRegion(
                            selectedCountryBelongsToCaricom
                        )
                    );
                } else {
                    dispatch(setSelectedCountryBelongsToOtherRegion(undefined));
                }

                dispatch(setSelectedCountry(country));

                await delay(500);

                // @ts-ignore
                const dropDownCountry = document.getElementById('country-select')?.innerText || '';
                if (dropDownCountry || country.country_name === ROMANIA_REGION.ROMANIA ) {
                    await delay(4000);
                    await createPDF(year, country.country_name);
                }
            }
        }
        setInProgress(false);
    }

    return {createPDF, generatePDFs, inProgress}
}

export default usePrintToPdf;
